import * as React from 'react';

import { Tiers, TiersListe } from '@mairistem/comptabilite';
import { useHistory } from 'react-router';

const TiersListeContainer = () => {
  const history = useHistory();

  const handleSelectTiers = (data: Tiers) => {
    history.push(`/tiers/${data.identifiant}`);
  };

  return (
    <TiersListe onSelect={handleSelectTiers} />
  );
};

export default TiersListeContainer;
